import { useMemo } from 'react';
import { EdgeProps as FlowEdgeProps } from 'reactflow';

import 'reactflow/dist/style.css';

import styled from 'styled-components';

import { noop } from '@utils/browser';

import { BaseBuilder, BaseBuilderProps } from 'ui/journey-builder/base-builder';
import { JourneyEdge, JourneyExtraEdge, LoopEdge } from 'ui/journey-builder/edge';
import { JourneyBuilderActionsContext } from 'ui/journey-builder/journey-builder-actions-context';
import { nodeTypes } from 'ui/journey-builder/node-types';

export type EdgeProps = FlowEdgeProps;

type JourneyBuilderProps = Partial<BaseBuilderProps> & { journeyId: string };

export const JourneyTemplateBuilder = ({ journeyId, ...rest }: JourneyBuilderProps) => {
  const edgeTypes = useMemo(
    () => ({
      defaultEdge: (edgeProps: EdgeProps) => <JourneyEdge journeyId={journeyId} {...edgeProps} />,
      loopEdge: (edgeProps: EdgeProps) => <LoopEdge {...edgeProps} />,
      journeyExtraEdge: (edgeProps: EdgeProps) => <JourneyExtraEdge {...edgeProps} />,
    }),
    [journeyId]
  );

  return (
    <JourneyBuilderActionsContext.Provider
      value={{
        handleDuplicate: noop,
        handleCreate: noop,
        // @ts-ignore doesnt matter, it shouldnt do anything
        handleDelete: noop,
      }}
    >
      <Container>
        <BaseBuilder nodeTypes={nodeTypes} edgeTypes={edgeTypes} {...rest} />
      </Container>
    </JourneyBuilderActionsContext.Provider>
  );
};

const Container = styled.div({
  height: '100%',
  width: '100%',
  '.node-actions, .assignee-list, foreignobject, .stacked-collapse-cards': {
    display: 'none',
  },
  'button:not(.react-flow__panel button)': {
    display: 'none',
  },
});
